<template>
  <section class="modules dashboard-grid">
    <slot name="menu"></slot>
    <div class="dashboard-grid__main">
      <div class="dashboard-grid__main__header">
        <slot name="title"></slot>
        <div class="no-select search">
          <IconSearch size="sm" />
          <input
            id="modelPath"
            ref="search__field"
            v-model="searchTerm"
            class="form-control search__field"
            type="text"
            placeholder="Buscar módulo"
            autocomplete="off"
          />
        </div>
      </div>
      <CustomTable
        v-if="listForTable.length > 0"
        id="module-list"
        class="dashboard-grid__table custom-scrollbar"
        :cols="tableHeaders"
        :list="listForTable"
      >
      </CustomTable>
      <div
        v-else
        class="settings-grid__empty-state"
      >
        Sem módulos para exibir 😿
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import slugify from 'slugify';

import CustomTable from '@/components/CustomTable.vue';
import IconSearch from '@/components/icons/IconSearch.vue';
import presets from '@/store/dicts/presets';

export default {
  name: 'Modules',
  components: {
    CustomTable,
    IconSearch,
  },
  data() {
    return {
      searchTerm: '',
      tableHeaders: [
        {
          name: 'module',
          label: 'Nome',
        },
        {
          name: 'id',
          label: 'Id',
        },
        {
          name: 'pagesThatContain',
          label: 'Páginas que contém',
          maxWidth: '130px',
        },
        {
          name: 'total',
          label: 'Total',
          maxWidth: '100px',
        },
      ],
    };
  },
  computed: {
    listForTable() {
      return this.searchTerm.length > 0
        ? this.foundOutModules
        : this.allModules;
    },
    foundOutModules() {
      return this.allModules.filter((module) => this.isModuleMatch(module));
    },
    allModules() {
      return this.dashboard.modules.map(
        ({ id = '', n: pagesThatContain, t: total }) => {
          const moduleName = presets.find((preset) => preset.module === id);

          return {
            module: moduleName?.name || '',
            pagesThatContain,
            total,
            id,
          };
        },
      );
    },
    ...mapState(['dashboard']),
  },
  methods: {
    isModuleMatch(module) {
      const term = slugify(this.searchTerm, { lower: true, strict: true });
      const { module: moduleName, id } = module;

      const customerString = [moduleName, id].join(' ');

      const customerSlug = slugify(customerString, {
        lower: true,
        strict: true,
      });

      return customerSlug.includes(term);
    },
  },
};
</script>

<style scoped lang="scss"></style>
